function hasCatalogOffer() {
  if (typeof Shopify !== 'undefined' && Shopify.designMode) return true;
  var po = window.data && window.data.theme && window.data.theme.productOffer;
  if (!po) return false;
  if (Array.isArray(po)) return po.some(function(o) { return String(o).toUpperCase() === 'CATALOG'; });
  if (typeof po === 'object') {
    if (po.type && String(po.type).toUpperCase() === 'CATALOG') return true;
    if (Array.isArray(po.offers)) return po.offers.some(function(o) { return o && String(o.type).toUpperCase() === 'CATALOG'; });
  }
  return false;
}

// Business hours helpers — a day counts as having real hours when its value
// parses as an "open - close" range and isn't the literal "Closed".
function parseBusinessHoursRange(value) {
  if (!value || typeof value !== 'string' || value.trim() === '') return null;
  if (value.trim().toLowerCase() === 'closed') return null;
  var parts = value.split('-');
  if (parts.length !== 2) return null;
  return parts[0].trim() + ' - ' + parts[1].trim();
}

var WEEK_DAYS = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];

// Social links — the DMO contact fields hold either a full URL or a bare
// handle (optionally with a leading "@"), so resolve both against the
// platform's profile base URL.
var SOCIAL_BASE_URLS = {
  instagram: 'https://instagram.com/',
  tiktok: 'https://tiktok.com/@',
  twitter: 'https://twitter.com/',
  facebook: 'https://facebook.com/',
  youtube: 'https://youtube.com/@'
};

function normalizeSocialUrl(value, platform) {
  if (!value || typeof value !== 'string' || value.trim() === '') return '';
  var v = value.trim();
  if (/^https?:\/\//i.test(v)) return v;
  if (v.indexOf('//') === 0) return 'https:' + v;
  var base = SOCIAL_BASE_URLS[platform];
  if (!base) return '';
  return base + v.replace(/^@/, '').replace(/^\//, '');
}

function normalizeWhatsappUrl(value) {
  if (!value || typeof value !== 'string' || value.trim() === '') return '';
  var v = value.trim();
  if (/^https?:\/\//i.test(v)) return v;
  var digits = v.replace(/[^\d]/g, '');
  return digits ? 'https://wa.me/' + digits : '';
}

function getSocialUrls(contact) {
  contact = contact || {};
  return {
    instagram: normalizeSocialUrl(contact.instagramUrl, 'instagram'),
    tiktok: normalizeSocialUrl(contact.tiktokUrl, 'tiktok'),
    twitter: normalizeSocialUrl(contact.twitterUrl, 'twitter'),
    facebook: normalizeSocialUrl(contact.facebookUrl, 'facebook'),
    youtube: normalizeSocialUrl(contact.youtubeUrl, 'youtube'),
    whatsapp: normalizeWhatsappUrl(contact.whatsappPhoneNumber)
  };
}

function hasSocialLinks(contact) {
  var urls = getSocialUrls(contact);
  return Object.keys(urls).some(function (k) { return !!urls[k]; });
}

function hasRealBusinessHours(profile) {
  var hours = (profile && profile.businessHours) || {};
  for (var i = 0; i < WEEK_DAYS.length; i++) {
    if (parseBusinessHoursRange(hours[WEEK_DAYS[i]])) return true;
  }
  return false;
}

(function() {
  function reapplyProfileVisibility() {
    var wrapper = document.querySelector('.profile-display-wrapper--subtle');
    if (wrapper) {
      wrapper.style.opacity = '1';
      wrapper.style.visibility = 'visible';
      wrapper.style.display = 'block';
    }

    var data = window.data;

    // Contact icons group — show if any contact info exists in DMO data.
    var contactGroup = document.getElementById('profileContactGroup');
    if (contactGroup && data && (
      (data.contact && (data.contact.email || data.contact.phone)) ||
      (data.profile && data.profile.location)
    )) {
      contactGroup.style.display = '';
    }

    // Shop nav links — only for Full Catalog offers on shop-related pages.
    var navLinks = document.getElementById('shopNavLinks');
    var mobileShopBtn = document.getElementById('shopMenuBtnMobile');
    if (!hasCatalogOffer()) {
      if (navLinks) navLinks.style.display = 'none';
      if (mobileShopBtn) mobileShopBtn.style.display = 'none';
    } else {
      var path = window.location.pathname;
      var needsShop = path.indexOf('/collections') > -1 ||
                      path.indexOf('/products') > -1 ||
                      path.indexOf('/pages/offers') > -1 ||
                      !!localStorage.getItem('pro2col_assessment_completed');
      if (needsShop) {
        if (navLinks) navLinks.style.display = 'flex';
        if (mobileShopBtn) mobileShopBtn.style.display = '';
      }
    }

    // "View Catalog" entries in the account popover/drawer — rendered hidden
    // (catalog_gated) and only shown for Full Catalog offers.
    var catalogItems = document.querySelectorAll('[data-account-catalog-item]');
    for (var ci = 0; ci < catalogItems.length; ci++) {
      catalogItems[ci].style.display = hasCatalogOffer() ? '' : 'none';
    }

    // Dropdown arrow — show if expanded data exists. businessHours only
    // counts when at least one day has real hours (an all-"Closed" week
    // renders nothing in the expanded section).
    var dropdownArrow = document.querySelector('.profile-display__dropdown-arrow');
    if (dropdownArrow && data && data.profile && (
      data.profile.personalMessage || hasRealBusinessHours(data.profile) || hasSocialLinks(data.contact)
    )) {
      dropdownArrow.style.display = '';
    }
  }

  function deferred() {
    reapplyProfileVisibility();
    setTimeout(reapplyProfileVisibility, 100);
    setTimeout(reapplyProfileVisibility, 400);
  }

  document.addEventListener('cart:update', deferred);
  document.addEventListener('cart:updated', deferred);
  document.addEventListener('cart:drawer:refreshed', deferred);
})();

// Populate site name + avatar + contact links from DMO data.
// (The legacy `initializeProfileDisplay` script was removed in the cleanup; this
// is the minimal wiring its consumers depend on.)
(function () {
  function applyProfile(data) {
    if (!data) return;
    var profile = data.profile || {};
    var contact = data.contact || {};

    var hasLogo = profile.logoUrl && String(profile.logoUrl).trim();
    var profileImageUrl = profile.profileImageUrl && String(profile.profileImageUrl).trim();

    // Logo — replaces avatar + site name when DMO provides logoUrl.
    document.querySelectorAll('[data-profile-logo]').forEach(function (wrap) {
      if (hasLogo) {
        wrap.removeAttribute('hidden');
        var logoImg = wrap.querySelector('[data-profile-logo-img]') || wrap.querySelector('img');
        if (logoImg) {
          logoImg.src = profile.logoUrl;
          logoImg.alt = profile.siteName || 'Logo';
        }
      } else {
        wrap.setAttribute('hidden', '');
      }
    });

    // Site name — hidden when logo is shown.
    document.querySelectorAll('[data-profile-name-section]').forEach(function (section) {
      if (hasLogo) {
        section.style.display = 'none';
      } else {
        section.style.display = '';
      }
    });
    document.querySelectorAll('[data-profile-name]').forEach(function (el) {
      if (hasLogo) {
        el.textContent = '';
      } else if (profile.siteName) {
        el.textContent = profile.siteName;
      }
    });

    // Avatar — profile image only (not logo). Wrapper starts `hidden` so empty <img> never shows broken icon.
    document.querySelectorAll('[data-profile-avatar]').forEach(function (wrap) {
      if (hasLogo) {
        wrap.setAttribute('hidden', '');
        wrap.classList.remove('profile-display__avatar--logo');
        return;
      }
      if (profileImageUrl) {
        wrap.removeAttribute('hidden');
        var img = wrap.querySelector('[data-profile-avatar-img]') || wrap.querySelector('img');
        if (img) {
          img.src = profileImageUrl;
          img.alt = profile.siteName || '';
        }
        wrap.classList.remove('profile-display__avatar--logo');
      } else {
        wrap.setAttribute('hidden', '');
      }
    });

    // Contact action buttons in the top row (mail / phone / location)
    var emailBtn = document.getElementById('profileEmailBtn');
    if (emailBtn) {
      if (contact.email) {
        emailBtn.setAttribute('href', 'mailto:' + contact.email);
        emailBtn.style.display = '';
      } else {
        emailBtn.style.display = 'none';
      }
    }
    var phoneBtn = document.getElementById('profilePhoneBtn');
    if (phoneBtn) {
      if (contact.phone) {
        phoneBtn.setAttribute('href', 'tel:' + contact.phone);
        phoneBtn.style.display = '';
      } else {
        phoneBtn.style.display = 'none';
      }
    }
    var locBtn = document.getElementById('profileLocationBtn');
    if (locBtn) {
      var loc = profile.location || {};
      var parts = [loc.address1, loc.address2, loc.city, loc.state, loc.zip, loc.country]
        .filter(function (p) { return p && String(p).trim(); });
      if (parts.length > 0) {
        locBtn.setAttribute(
          'href',
          'https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent(parts.join(', '))
        );
        locBtn.style.display = '';
      } else {
        locBtn.style.display = 'none';
      }
    }

    // Contact group wrapper — show when any of the three icons are visible
    var contactGroup = document.getElementById('profileContactGroup');
    if (contactGroup) {
      var anyVisible = false;
      [emailBtn, phoneBtn, locBtn].forEach(function (el) {
        if (el && el.style.display !== 'none') anyVisible = true;
      });
      contactGroup.style.display = anyVisible ? '' : 'none';
    }

    // Expanded section text nodes (location / email / phone)
    var loc2 = profile.location || {};
    var locText = [loc2.address1, loc2.address2, loc2.city, loc2.state, loc2.zip, loc2.country]
      .filter(function (p) { return p && String(p).trim(); }).join(', ');
    document.querySelectorAll('[data-profile-location] > span').forEach(function (el) {
      if (locText) el.textContent = locText;
    });
    document.querySelectorAll('[data-profile-email] > span').forEach(function (el) {
      if (contact.email) el.textContent = contact.email;
    });
    document.querySelectorAll('[data-profile-phone] > span').forEach(function (el) {
      if (contact.phone) el.textContent = contact.phone;
    });

    // Personal message
    document.querySelectorAll('[data-profile-message]').forEach(function (el) {
      if (profile.personalMessage) el.textContent = profile.personalMessage;
    });

    // Social links — set the resolved URL on each icon, hide the ones without
    // a value and the whole row when none is set.
    var socialUrls = getSocialUrls(contact);
    var anySocial = false;
    Object.keys(socialUrls).forEach(function (platform) {
      document.querySelectorAll('[data-social-' + platform + ']').forEach(function (link) {
        var url = socialUrls[platform];
        if (url) {
          link.setAttribute('href', url);
          link.setAttribute('target', '_blank');
          link.setAttribute('rel', 'noopener noreferrer');
          link.style.display = '';
          anySocial = true;
        } else {
          link.removeAttribute('href');
          link.style.display = 'none';
        }
      });
    });
    document.querySelectorAll('.profile-display__social-icons').forEach(function (row) {
      row.style.display = anySocial ? '' : 'none';
    });

    // Dropdown arrow — the cart-event path (reapplyProfileVisibility) only
    // fires on cart changes, so the arrow must also be resolved here, on the
    // reliable init/dmo:data:loaded path, or hours never show on plain loads.
    var dropdownArrow = document.querySelector('.profile-display__dropdown-arrow');
    if (dropdownArrow) {
      dropdownArrow.style.display =
        (profile.personalMessage || hasRealBusinessHours(profile) || anySocial) ? '' : 'none';
    }

    // Weekly schedule — fill each day's time from profile.businessHours.
    // The block renders hidden and only shows when at least one day has real
    // hours; days without a parsable range show the localized "Closed".
    var businessHours = profile.businessHours || {};
    document.querySelectorAll('[data-profile-schedule]').forEach(function (schedule) {
      if (!hasRealBusinessHours(profile)) {
        schedule.style.display = 'none';
        return;
      }
      schedule.style.display = '';
      var closedLabel = schedule.getAttribute('data-closed-label') || 'Closed';
      schedule.querySelectorAll('[data-schedule-day]').forEach(function (item) {
        var timeEl = item.querySelector('.profile-display__schedule-time');
        if (!timeEl) return;
        var range = parseBusinessHoursRange(businessHours[item.getAttribute('data-schedule-day')]);
        timeEl.textContent = range || closedLabel;
      });
    });
  }

  function init() {
    if (window.data) applyProfile(window.data);
  }

  document.addEventListener('dmo:data:loaded', function (e) {
    applyProfile((e && e.detail) || window.data || null);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();

// Fallback initialization for toggle functionality
document.addEventListener('DOMContentLoaded', function() {
  const toggleButton = document.querySelector('[data-profile-toggle-btn]');
  const expandedSection = document.querySelector('[data-profile-expanded]');

  if (toggleButton && expandedSection && !toggleButton.hasAttribute('data-listener-added')) {
    toggleButton.setAttribute('data-listener-added', 'true');

    toggleButton.addEventListener('click', function(e) {
      e.preventDefault();

      const isExpanded = toggleButton.getAttribute('aria-expanded') === 'true';
      const newExpandedState = !isExpanded;

      toggleButton.setAttribute('aria-expanded', newExpandedState.toString());

      if (newExpandedState) {
        expandedSection.style.display = 'block';
      } else {
        expandedSection.style.display = 'none';
      }
    });
  }

  // Set dynamic header height for main content margin
  const profileWrapper = document.querySelector('.profile-display-wrapper--subtle');
  if (profileWrapper) {
    function updateHeaderHeight() {
      const height = profileWrapper.offsetHeight;
      document.documentElement.style.setProperty('--profile-header-height', `${height}px`);
    }

    // Set initial height
    updateHeaderHeight();

    // Update on resize
    window.addEventListener('resize', updateHeaderHeight);

    // Update when content changes (e.g., expand/collapse)
    const observer = new MutationObserver(updateHeaderHeight);
    observer.observe(profileWrapper, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'class']
    });
  }

  // ── Shop Menu ─────────────────────────────────────────────────────
  (function() {
    var navLinks      = document.getElementById('shopNavLinks');
    var navBtnType    = document.getElementById('shopNavBtnType');
    var navBtnNeed    = document.getElementById('shopNavBtnNeed');
    var navBtns       = [navBtnType, navBtnNeed];
    var mobileShopBtn = document.getElementById('shopMenuBtnMobile');
    var megaMenu      = document.getElementById('shopMegaMenu');
    var mobileMenu    = document.getElementById('shopMobileMenu');
    if (!megaMenu || !mobileMenu) return;

    function isHomePage() {
      var p = window.location.pathname;
      return p === '/' || /^\/[a-z]{2}-[a-z]{2}\/?$/i.test(p);
    }

    function shouldShowShop() {
      if (new URLSearchParams(window.location.search).get('p2c_reveal') === 'true') return true;
      if (isHomePage()) return false;
      if (window.location.pathname.includes('/pages/enrollment')) return false;
      if (window.location.pathname.includes('/collections')) return true;
      if (window.location.pathname.includes('/products')) return true;
      if (!new URLSearchParams(window.location.search).get('site')) return false;
      if (window.location.pathname.includes('/pages/offers')) return true;
      if (localStorage.getItem('pro2col_assessment_completed')) return true;
      return false;
    }

    function showNavLinks() {
      if (!hasCatalogOffer() || !shouldShowShop()) {
        if (navLinks) navLinks.style.display = 'none';
        if (mobileShopBtn) mobileShopBtn.style.display = 'none';
        return;
      }
      if (navLinks) navLinks.style.display = 'flex';
      if (mobileShopBtn) mobileShopBtn.style.display = '';
    }

    // "View Catalog" entries in the account popover/drawer — rendered hidden
    // (catalog_gated) and only shown for Full Catalog offers, on any page.
    function syncCatalogItems() {
      var items = document.querySelectorAll('[data-account-catalog-item]');
      for (var i = 0; i < items.length; i++) {
        items[i].style.display = hasCatalogOffer() ? '' : 'none';
      }
    }

    showNavLinks();
    syncCatalogItems();

    document.addEventListener('dmo:data:loaded', function() {
      showNavLinks();
      syncCatalogItems();
      updatePromoFromFlagship();
    });

    function updatePromoFromFlagship() {
      var flagship = window.data && window.data.theme && window.data.theme.flagshipProduct;
      if (!flagship || !flagship.productHandle) return;

      var url = '/products/' + flagship.productHandle;
      var img = flagship.imageUrls && flagship.imageUrls[0];
      var name = flagship.productName || '';

      var desktopPromo = document.getElementById('shopMegaMenuPromo');
      var desktopImgLink = document.getElementById('shopMegaMenuPromoImgLink');
      var desktopImg = document.getElementById('shopMegaMenuPromoImg');
      var desktopLink = document.getElementById('shopMegaMenuPromoLink');
      var mobilePromo = document.getElementById('shopMobileMenuPromo');
      var mobileImg = document.getElementById('shopMobileMenuPromoImg');
      var mobileLink = document.getElementById('shopMobileMenuPromoLink');

      if (desktopPromo) {
        desktopPromo.removeAttribute('hidden');
        if (desktopImgLink) { desktopImgLink.href = url; if (img) { desktopImgLink.removeAttribute('hidden'); } }
        if (desktopImg && img) { desktopImg.src = img; desktopImg.alt = name; }
        if (desktopLink) { desktopLink.href = url; desktopLink.childNodes[0].textContent = name + ' '; }
      }
      if (mobilePromo) {
        mobilePromo.removeAttribute('hidden');
        if (mobileImg && img) { mobileImg.src = img; mobileImg.alt = name; mobileImg.removeAttribute('hidden'); }
        if (mobileLink) { mobileLink.href = url; mobileLink.textContent = name + ' →'; }
      }
    }

    function isMobile() { return window.innerWidth <= 768; }

    // Show only the column matching colIndex in the mega menu
    function showMenuColumn(colIndex) {
      megaMenu.querySelectorAll('.shop-megamenu__column').forEach(function(col, i) {
        col.style.display = i === colIndex ? '' : 'none';
      });
    }

    function openMenu(colIndex) {
      if (!isMobile()) {
        showMenuColumn(colIndex);
        // Position floating panel below the hovered button
        var btn = navBtns[colIndex];
        if (btn) {
          var rect = btn.getBoundingClientRect();
          megaMenu.style.top = (rect.bottom + 8) + 'px';
          megaMenu.style.left = rect.left + 'px';
        }
        megaMenu.removeAttribute('hidden');
      }
      navBtns.forEach(function(btn, i) {
        if (btn) btn.setAttribute('aria-expanded', i === colIndex ? 'true' : 'false');
      });
    }

    function closeMenu() {
      megaMenu.setAttribute('hidden', '');
      mobileMenu.setAttribute('hidden', '');
      document.body.style.overflow = '';
      navBtns.forEach(function(btn) {
        if (btn) btn.setAttribute('aria-expanded', 'false');
      });
      // Restore all columns for next open
      megaMenu.querySelectorAll('.shop-megamenu__column').forEach(function(col) {
        col.style.display = '';
      });
      mobileMenu.querySelectorAll('.shop-mobile-menu__panel').forEach(function(p) {
        p.setAttribute('hidden', '');
      });
      var main = document.getElementById('shopMobileMain');
      if (main) main.removeAttribute('hidden');
    }

    // ── Mobile: Shop button opens the mobile drawer ───────────────
    if (mobileShopBtn) {
      mobileShopBtn.addEventListener('click', function(e) {
        e.stopPropagation();
        if (!isMobile()) return;
        mobileMenu.removeAttribute('hidden');
        document.body.style.overflow = 'hidden';
      });
    }

    // ── Desktop: hover each nav button to open its column ─────────
    var closeTimer = null;
    function scheduleClose() { closeTimer = setTimeout(closeMenu, 120); }
    function cancelClose()   { clearTimeout(closeTimer); }

    navBtns.forEach(function(btn, colIndex) {
      if (!btn) return;
      btn.addEventListener('mouseenter', function() {
        if (isMobile()) return;
        cancelClose();
        openMenu(colIndex);
      });
    });

    var profileHeader = document.querySelector('.profile-display-wrapper--subtle');
    if (profileHeader) {
      profileHeader.addEventListener('mouseleave', function() {
        if (isMobile()) return;
        scheduleClose();
      });
      profileHeader.addEventListener('mouseenter', function() {
        if (isMobile()) return;
        cancelClose();
      });
    }

    megaMenu.addEventListener('mouseenter', function() {
      if (isMobile()) return;
      cancelClose();
    });
    megaMenu.addEventListener('mouseleave', function() {
      if (isMobile()) return;
      scheduleClose();
    });

    // All close buttons (mobile)
    mobileMenu.querySelectorAll('.shop-mobile-menu__close').forEach(function(btn) {
      btn.addEventListener('click', closeMenu);
    });

    // Mobile panel navigation
    mobileMenu.querySelectorAll('[data-mobile-panel]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var targetId = btn.getAttribute('data-mobile-panel');
        mobileMenu.querySelectorAll('.shop-mobile-menu__panel').forEach(function(p) {
          p.setAttribute('hidden', '');
        });
        var target = document.getElementById(targetId);
        if (target) target.removeAttribute('hidden');
      });
    });

    // ESC to close
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') closeMenu();
    });
  })();
});
